import { asyncScheduler, Observable, Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

export enum IntersectionStatus {
  Visible = 'Visible',
  NotVisible = 'NotVisible'
}

export const fromIntersectionObserver = (
  element: HTMLElement,
  config: IntersectionObserverInit,
  throttle = 0
) => new Observable<IntersectionStatus>(subscriber => {
  if (typeof IntersectionObserver === 'function') {
    const subject$ = new Subject<{
      entry: IntersectionObserverEntry;
    }>();

    const intersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          subject$.next({ entry });
        });
      },
      config
    );

    const subscription = subject$.pipe(
      throttleTime(throttle, asyncScheduler, {
          leading: true,
          trailing: true
        })
    ).subscribe(({ entry }) => {
      const isEntryVisible = entry.isIntersecting;

      if (isEntryVisible) {
        subscriber.next(IntersectionStatus.Visible);
      } else {
        subscriber.next(IntersectionStatus.NotVisible);
      }
    });

    intersectionObserver.observe(element);

    return {
      unsubscribe() {
        intersectionObserver.disconnect();
        subscription.unsubscribe();
      }
    };
  } else {
    return {
      unsubscribe() {
        // do nothing
      }
    };
  }
});
